<template>
  <ul class="reply-list" v-if="isOpen">
    <li v-for="(replyMessage, index) in podMessage.replyMessages" :key="index">
      <PodMessageReplyMessage :message="replyMessage" />
    </li>
  </ul>
</template>

<script>
import PodMessageReplyMessage from '@/components/Pages/Connections/ConnectionApp/components/PodMessage/Parts/PodMessageReplyMessage.vue'

export default {
  props : {
    isOpen      : {
      default : false
    },

    podMessage  : {
      default : null
    }
  },

  components : {
    PodMessageReplyMessage
  }
}
</script>